import React, { useState } from "react";

type RouteKey = "home" | "sandbox" | "login" | "register" | "dashboard";

type HeaderProps = {
  active: RouteKey;
  isLoggedIn: boolean;
  onLogout: () => void;
};

export default function Header({ active, isLoggedIn, onLogout }: HeaderProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="bg-white ring-1 ring-gray-200">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-14 relative">
          <a
            href="#/"
            className="flex items-center gap-2"
          >
            <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                />
              </svg>
            </div>
            <span className="text-sm sm:text-xl font-bold text-gray-900 min-w-0 truncate">LinkyShorty</span>
          </a>
          {/* hamburger button shown only on small screens */}
          <button
            className="sm:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onClick={() => setMobileOpen((o) => !o)}
            aria-label="Menü öffnen"
            aria-expanded={mobileOpen}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          <nav className={`${mobileOpen ? "flex" : "hidden"} flex-col sm:flex-row sm:flex items-center gap-2 sm:gap-2 sm:static sm:bg-transparent absolute sm:relative bg-white w-full left-0 top-full sm:top-auto sm:w-auto shadow sm:shadow-none`}
          >
            <a
              href="#/"
              onClick={() => setMobileOpen(false)}
              className={
                active === "home"
                  ? "text-blue-700 font-medium text-sm block w-full text-center sm:inline"
                  : "text-gray-700 hover:text-gray-900 block w-full text-center sm:inline"
              }
            >
              Home
            </a>
            <a
              href="#/sandbox"
              onClick={() => setMobileOpen(false)}
              className={
                active === "sandbox"
                  ? "text-blue-700 font-medium text-sm block w-full text-center sm:inline"
                  : "text-gray-700 hover:text-gray-900 text-sm block w-full text-center sm:inline"
              }
            >
              UI Sandbox
            </a>
            {isLoggedIn ? (
              <>
                <a
                  href="#/dashboard"
                  onClick={() => setMobileOpen(false)}
                  className={
                    active === "dashboard"
                      ? "text-blue-700 font-medium text-sm block w-full text-center sm:inline"
                      : "text-gray-700 hover:text-gray-900 text-sm block w-full text-center sm:inline"
                  }
                >
                  Dashboard
                </a>
                <button
                  type="button"
                  onClick={() => {
                    setMobileOpen(false);
                    onLogout();
                  }}
                  className="text-gray-700 hover:text-gray-900 text-sm block w-full text-center sm:inline"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <a
                  href="#/login"
                  onClick={() => setMobileOpen(false)}
                  className={
                    active === "login"
                      ? "text-blue-700 font-medium text-sm block w-full text-center sm:inline"
                      : "text-gray-700 hover:text-gray-900 text-sm block w-full text-center sm:inline"
                  }
                >
                  Login
                </a>
                <a
                  href="#/register"
                  onClick={() => setMobileOpen(false)}
                  className={
                    active === "register"
                      ? "text-blue-700 font-medium text-sm block w-full text-center sm:inline"
                      : "text-gray-700 hover:text-gray-900 text-sm block w-full text-center sm:inline"
                  }
                >
                  Register
                </a>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}
